import { Link } from "react-router-dom";
import { genres } from "@/mocks/genres";
import { comics } from "@/mocks/comics";

export default function GenreSection() {
  return (
    <section className="section-pad bg-background-100">
      <div className="container-x">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <p className="mb-1 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-400" />
              分类导航
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              按题材，直接找到想看的那部
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              剧情分类全，热门韩漫一网打尽。校园、奇幻、都市、恋爱、悬疑，进分类就能找，不用全网乱搜。
            </p>
          </div>
          <Link to="/category/all" className="btn-ghost hidden shrink-0 px-3 py-2 text-sm sm:inline-flex">
            全部漫画 <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {genres.map((g) => {
            const count = comics.filter((c) => c.genre === g.id).length;
            return (
              <Link
                key={g.id}
                to={`/category/${g.id}`}
                className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
              >
                <div
                  className={`mb-4 flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-br text-xl text-background-50 ${g.gradient}`}
                >
                  <i className={g.icon} />
                </div>
                <h3 className="flex items-center gap-2 text-lg font-bold text-foreground-950">
                  {g.name}漫
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                    {count}部
                  </span>
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{g.desc}</p>
                <span className={`mt-4 inline-flex items-center gap-1 text-sm font-medium ${g.accentText}`}>
                  进入分类
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}